export default {
  namespaced: true,

  state: {
    data: {
      isOpen: false,
    },
  },

  getters: {
    getIsOpen: (state) => state.data.isOpen,
  },

  actions: {
    setSideMenuOpen({ commit }, payload) {
      const isOpen = payload;
      commit("SET_IS_OPEN", isOpen);
    },
  },

  mutations: {
    SET_IS_OPEN(state, data) {
      state.data.isOpen = data;
    },
  },
};
